var map = {
	"./DrLubhani/ChangeColor": [
		800,
		179
	],
	"./Ganga/ChangeColor": [
		802,
		185
	],
	"./Indus/ChangeColor": [
		804,
		198
	],
	"./Kabini/ChangeColor": [
		806,
		205
	],
	"./Kaveri/ChangeColor": [
		716,
		21
	],
	"./Luni/ChangeColor": [
		808,
		211
	],
	"./Narmada/ChangeColor": [
		810,
		214
	],
	"./Neyyar/ChangeColor": [
		812,
		221
	],
	"./Periyar/ChangeColor": [
		814,
		224
	],
	"./SAANVI/ChangeColor": [
		816,
		234
	],
	"./Sabarmathi/ChangeColor": [
		818,
		241
	],
	"./Sparsh/ChangeColor": [
		820,
		247
	],
	"./Sutlej/ChangeColor": [
		822,
		251
	],
	"./Yamuna/ChangeColor": [
		824,
		257
	],
	"./pamba/ChangeColor": [
		826,
		266
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2066;
module.exports = webpackAsyncContext;